module.exports = __webpack_public_path__ + "img/QR-2999.d6c21256.png";